import { render, staticRenderFns } from "./ActionsForOrgUnit.vue?vue&type=template&id=fef7f7d8&scoped=true&lang=html&"
import script from "./ActionsForOrgUnit.vue?vue&type=script&lang=js&"
export * from "./ActionsForOrgUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef7f7d8",
  null
  
)

export default component.exports